// 引入公共模块
import { 
  initActivityBannerHandler, 
  mergeParams,
  addParamsToLinksHandler,
  initScrollHandler, 
  initNavBarHandler, 
  navSolutionsTabHandler 
} from './common.js';

// 命名空间模式
const App = {
  init() {
    initActivityBannerHandler(); //6.0专题横幅
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    initScrollHandler();
    initNavBarHandler();
    navSolutionsTabHandler();
    this.upgradationSwiper();
  },
  upgradationSwiper() {
    // 在线开发升级视频切换
    const functionSwiper = new Swiper('.upgradation-swiper-container', {
      direction: 'vertical',
      autoplay: false,
      wrapperClass: 'upgradation-swiper-wrapper',
      slideClass: 'upgradation-swiper-slide',
      // 启用分页器
      pagination: {
        el: '.upgradation-pagination',
        clickable: true, // 分页器可点击
      },
      on: {
        autoplay: function () {
          $('.upgradation-item').eq(this.activeIndex).addClass('active');
          $('.upgradation-item').not(':eq(' + this.activeIndex + ')').removeClass('active')
        },
        slideChangeTransitionEnd: function (functionSwiper, event) {
          $('.upgradation-item').eq(this.activeIndex).addClass('active')
          $('.upgradation-item').not(':eq(' + this.activeIndex + ')').removeClass('active')
        }
      }
    })
    $('.upgradation-content').on('click', '.upgradation-item', function () {
      $(this).addClass('active').siblings().removeClass('active');
      const tabIndex = $(this).index();
      functionSwiper.slideTo(tabIndex, 1000, false);
    })
  },
};

// 文档加载后初始化
$(function () {
  App.init();
});
